"use strict";
/**
 * Employment Coverage Types
 *
 * Types for employment coverage analysis — identifying gaps between
 * employment records for each collaborator.
 *
 * @see GH#11 - Employment coverage visibility in collaborator views
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.COVERAGE_STATUS_LABELS = exports.CoverageStatus = void 0;
// ─── Coverage Status Enum ───────────────────────────────────────────────────
/**
 * Overall coverage status for a collaborator's employment history.
 */
var CoverageStatus;
(function (CoverageStatus) {
    CoverageStatus["full"] = "full";
    CoverageStatus["has_gaps"] = "has_gaps";
    CoverageStatus["no_employments"] = "no_employments";
})(CoverageStatus || (exports.CoverageStatus = CoverageStatus = {}));
exports.COVERAGE_STATUS_LABELS = {
    [CoverageStatus.full]: "Cubierto",
    [CoverageStatus.has_gaps]: "Con huecos",
    [CoverageStatus.no_employments]: "Sin empleos",
};
